import React, { useEffect, useState } from 'react'
import RequestCard from '../../components/Cards/RequestCard'
import image1 from "../../assets/images/gabrielle-henderson-DgCPTkDqhHg-unsplash.jpg"
import { useLocation, useOutletContext } from 'react-router-dom'
import Modal from '../../../components/Modal'
import TextAreaEditor from '../../../components/Form/TextAreaEditor'
import { CgClose } from 'react-icons/cg'
import Input from '../../../components/Form/Input'
import Select from '../../../components/Form/Select'
import ImagePicker from "../../../components/ImagePicker"
import image2 from "../../assets/Illustrations/marketing1.png"
import { useDispatch, useSelector } from 'react-redux';
import { fetchRequests, addRequest } from '../../../redux/requestSlice';
import ImageWithFallback from '../../components/ImageWithFallback'
import { END_POINT, REQUEST_API_END_POINT } from '../../../utils/constant'
import RowPagination from "../../components/Pagination"
import ButtonBlack from '../../../components/Buttons/ButtonBlack'
import axios from 'axios'

const Request = () => {
    const dispatch = useDispatch();
    const { requests, loading,  loadingRequests, loadingSave, error } = useSelector((state) => state.requests)
    const { user } = useSelector((state) => state.user)
    const [selectedType, setSelectedType] = useState("Tous")
    const [filteredRequests, setFilteredRequests] = useState([])
    const [description, setDescription] = useState('')
    const [newRequest, setNewRequest] = useState({
        title: '',
        user_id: user?.id,
        description: '',
        type: '',
        category_id: '',
        photo: ''
    });
    const [showAddModal, setshowAddModal] = useState(false);
    const [filters, setFilters] = useState({
        // keyword: '',
        // location: '',
        page: 1,
        limit: 10
      });
    //   const {sho}
      const {showNotif, setShowNotif} = useOutletContext()
      const [isLoading, setisLoading] = useState(false)

    useEffect(() => {
        dispatch(fetchRequests(filters));
    }, [dispatch,  filters.page]);

    useEffect(() => {
        if (selectedType === 'Tous') {
            setFilteredRequests(requests?.data)
        } else {
            setFilteredRequests(requests?.data?.filter(req => req.type === selectedType));
        }
    }, [selectedType, requests]);

    const handleFilter = (type) => {
        setSelectedType(type)
    };

    const handleSubmit = async () => {
        setisLoading(true)
    //   setNewRequest((prevState) => ({
    //     ...prevState,
    //     description: description,  // Mettre la description à jour
    //   }));

      console.log("Ajout de reqete ",newRequest)
      const dataToSend = new FormData();
      Object.keys(newRequest).forEach((key) => {
        if (key === "photo" && newRequest?.photo instanceof File) {
            dataToSend.append("image", newRequest?.photo);
        } else {
            dataToSend.append(key, newRequest[key]);
        }
      });
      dataToSend.forEach((key, value)=>console.log("Valeur saisie : ",key, value))
        // dispatch(addRequest(dataToSend));
        await axios.post(`${REQUEST_API_END_POINT}/save`, dataToSend)
         .then((response)=>{
            console.log(response.data);
            if(response.data?.newRequest){
                dispatch(fetchRequests(filters));
                setShowNotif({...showNotif, variant: "success", message: response.data?.message, show: true})
                setshowAddModal(false);
            }            
         })
         .catch((err) => {
            console.log(err)
            setShowNotif({...showNotif, variant: "danger", message:"Une erreur est survenue", show: true})
         }).finally(() => {
            setisLoading(false)
         })
            // return response.data;
        
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setNewRequest({
            ...newRequest,
            [name]: value,
        });
    };

    const  { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname])

    const handlePageChange = (newPage) => {
        setFilters((prev) => ({
          ...prev,
          page: newPage+1,
        }));
      };

    return (
        <div className='w-full px-6 lg:px-20 xl:px-40'>
            <div className="grid grid-cols-2 py-6 items-center justify-between">
                <h1 className="text-5xl font-bold text-start leading-normal">
                    Faites un revues des requêtes des candidats
                </h1>
                <div className="flex justify-center">
                <img src={image2} alt="image de requête" className='w-[350px]' />
                </div>
            </div>

            <div className="flex items-end justify-between top-20 border-b w-full my-4 text-sm bg-white pt-2 mb-6">
                <div>
                    <button
                        onClick={() => handleFilter('Tous')}
                        className={`px-6 py-2 border-b-2 font-bold ${selectedType === 'Tous' ? 'text-primary-black' : 'text-primary-text'}`}
                    >
                        Tous
                    </button>
                    <button
                        onClick={() => handleFilter('Emploi')}
                        className={`px-6 py-2 ${selectedType === 'Emploi' ? 'text-primary-black' : 'text-primary-text'}`}
                    >
                        Emploi
                    </button>
                    <button
                        onClick={() => handleFilter('Stage')}
                        className={`px-6 py-2 ${selectedType === 'Stage' ? 'text-primary-black' : 'text-primary-text'}`}
                    >
                        Stage
                    </button>
                    <button
                        onClick={() => handleFilter('Divers')}
                        className={`px-6 py-2 ${selectedType === 'Divers' ? 'text-primary-black' : 'text-primary-text'}`}
                    >
                        Divers
                    </button>
                </div>
                <div className='pb-1'>
                    <button 
                        onClick={() => setshowAddModal(true)}
                        className='relative bg-primary-black p-2 rounded-sm text-white'
                    >
                        Publier une offre
                    </button>
                </div>
            </div>

            <p className='font-bold text-start mb-6'>{requests?.total || 0} Résultats</p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                {filteredRequests?.map((item) => (
                    <RequestCard key={item.id} item={item} loading={loadingRequests} />
                ))}
            </div>
            <RowPagination
            currentPage={filters?.page || 1}
            setCurrentPage={handlePageChange}
            totalPages={requests?.last_page }
            />

            <Modal isOpen={showAddModal} onClose={() => setshowAddModal(false)}>
                <div className="p-6">
                    <div className="flex justify-end">
                        <button onClick={() => setshowAddModal(false)} className='px-2 py-2 rounded-md border text-primary-black'>
                            <CgClose />
                        </button>
                    </div>
                    <div className="flex justify-between items-center mt-4">
                        <div className="flex gap-4 items-center">
                            <ImageWithFallback src={END_POINT+ "/storage"+ user.photo} alt="img" className='w-10 h-10 rounded-full object-cover' defaultType='user'/>
                            <div className='flex flex-col justify-between'>
                                <h1 className='text-lg font-semibold text-start'>{user?.candidate_profile?.name}</h1>
                                <p className='text-sm text-start'>{user?.candidate_profile?.address}</p>
                            </div>
                        </div>
                        <ButtonBlack 
                        isLoading={isLoading}
                            onClick={handleSubmit}
                            className='relative bg-primary-black px-4 py-2 rounded-sm text-white'
                        >
                            Publier la requête
                        </ButtonBlack>
                    </div>

                    <hr className='my-4' />

                    <Input label="Titre" name="title" onChange={handleChange} />
                    <Select label="Type de Requête" name="type" onChange={handleChange} options={['Emploi', 'Stage', 'Divers']} />
                    <TextAreaEditor label="Description" name="description" value={description} setValue={(value)=> setNewRequest((prevState) => ({...prevState, description: value}))}/>
                    <br />
                    <ImagePicker name='image' onImageChange={handleChange}/>
                </div>
            </Modal>
        </div>
    );
};

export default Request;
